import script from "./TiktokTagAddEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TiktokTagAddEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./TiktokTagAddEditDialog.vue?vue&type=style&index=0&id=0041e493&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0041e493"]])

export default __exports__